import React from "react";

const UpSarpanchPage = () => {
  const currentDate = new Date().toLocaleDateString("en-IN");
  const currentTime = new Date().toLocaleTimeString("en-IN");

  const stateLogo = `${process.env.PUBLIC_URL}/images/sj1.jpg`;
  const gpLogo = `${process.env.PUBLIC_URL}/images/gp.jpeg`;
  const upsarpanchPhoto = `${process.env.PUBLIC_URL}/images/upsarpanch.jpeg`;

  return (
    <div style={styles.container}>
      
      {/* Header */}
      <header style={styles.header}>
        <img src={stateLogo} alt="Logo" style={styles.leftLogo} />
        
        <div style={styles.headerText}>
          <h2 style={styles.govTitle}>महाराष्ट्र शासन</h2>
          <h3 style={styles.depTitle}>ग्रामविकास विभाग</h3>
          <h1 style={styles.mainTitle}>ग्रामपंचायत भालेवाडी</h1>
          <p style={styles.subTitle}>पंचायत समिती करंजा | जिल्हा परिषद वर्धा</p>
          <p style={styles.timestamp}>
            अद्ययावत: {currentDate} | वेळ: {currentTime}
          </p>
        </div>

        <img src={gpLogo} alt="GP Logo" style={styles.rightLogo} />
      </header>

      {/* Profile */}
      <section style={styles.profileCard}>
        <img src={upsarpanchPhoto} alt="उपसरपंच" style={styles.profilePhoto} />
        <div>
          <h2 style={styles.name}>
            सन्माननीय उपसरपंच: श्री ------
          </h2>
          <p style={styles.motto}>
            "तुमचा अनुभव, माझ्या कामाची दिशा"
          </p>
        </div>
      </section>

      {/* संदेश */}
      <section style={styles.section}>
        <h3 style={styles.sectionTitle}>उपसरपंचांचा संदेश</h3>
        <p>
          तुमच्या सहकार्याने भालेवाडी गावाचा सर्वांगीण विकास साधणे ही आमची
          प्राथमिकता आहे. नागरिकांच्या समस्या जाणून घेऊन त्या सोडवण्यासाठी
          आम्ही सतत प्रयत्नशील आहोत.
        </p>
      </section>

      {/* कार्य */}
      <section style={styles.section}>
        <h3 style={styles.sectionTitle}>लोकसंपर्क व विकासकार्य</h3>
        <ul style={styles.list}>
          <li>ग्रामसभेत सक्रिय सहभाग</li>
          <li>महिला व युवक गटांशी संवाद</li>
          <li>शासकीय योजनांचे मार्गदर्शन</li>
          <li>तक्रार निवारण व तत्पर सेवा</li>
        </ul>
      </section>

      {/* Vision */}
      <section style={styles.section}>
        <h3 style={styles.sectionTitle}>भविष्याची दृष्टी</h3>
        <p>
          सरपंच आणि सदस्यांच्या सहकार्याने भालेवाडीला आदर्श गाव बनवण्याचा आमचा संकल्प आहे.
        </p>
      </section>

      <footer style={styles.footer}>
        © 2025 ग्रामपंचायत भालेवाडी | सर्व हक्क राखीव
      </footer>
    </div>
  );
};

// Internal CSS
const styles = {
  container: {
    maxWidth: "900px",
    margin: "auto",
    padding: "20px",
    background: "#fff",
    borderRadius: "12px",
    fontFamily: "Noto Sans Devanagari, sans-serif",
    boxShadow: "0 5px 20px rgba(0,0,0,0.15)",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "4px solid #1b5e20",
    paddingBottom: "12px",
    marginBottom: "25px",
  },
  leftLogo: { width: "80px", height: "80px" },
  rightLogo: { width: "80px", height: "80px" },
  headerText: { textAlign: "center" },
  govTitle: { margin: 0, color: "#2e7d32" },
  depTitle: { margin: "3px 0", color: "#2e7d32" },
  mainTitle: { margin: 0, color: "#1b5e20", fontSize: "28px" },
  subTitle: { fontSize: "16px", margin: "3px 0" },
  timestamp: { color: "#c62828", fontSize: "14px", fontWeight: "bold" },

  profileCard: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    background: "#e8f5e9",
    padding: "20px",
    borderRadius: "12px",
  },
  profilePhoto: {
    width: "120px",
    height: "120px",
    borderRadius: "50%",
    border: "4px solid #fff",
  },
  name: { margin: 0, color: "#1b5e20", fontSize: "20px" },
  motto: { marginTop: "5px", fontStyle: "italic", color: "#388e3c" },

  section: {
    background: "#f9fdf9",
    padding: "16px",
    borderRadius: "10px",
    marginTop: "20px",
  },
  sectionTitle: {
    borderBottom: "2px solid #2e7d32",
    paddingBottom: "5px",
    color: "#1b5e20",
  },
  list: { marginTop: "10px", lineHeight: "1.8" },

  footer: {
    textAlign: "center",
    paddingTop: "15px",
    marginTop: "20px",
    borderTop: "1px solid #ccc",
    color: "#444",
  },
};

export default UpSarpanchPage;
